<template>
  <div class="today_task">
    <div class="nav">
        <div class="content">
          <i @click="goBack()"></i>
          <span @click="customer()">客服</span>
        </div>
      </div>
      <div class="header"></div>
      <div class="block guaguale" v-if="hasExperienceTask">
        <div class="title">
          <span class="step_num">1</span>
          <span class="main">{{experienceTitle}}</span>
          <span class="times">({{experienceStep}})</span>
        </div>
        <div class="banner" @click="jumpUrl(experienceTask.jump_url)">
          <img :src="experienceImg"/>
        </div>
      </div>

      <div class="block try_play">
        <div class="title">
          <span class="step_num" v-if="!hasExperienceTask">1</span>
          <span class="step_num" v-else>2</span>
          <span class="main">打开试玩</span>
          <span class="description">(完成1个试玩任务)</span>
          <span class="times">{{demoTask.title_2}}</span>
          <div @click="refreshTask()">换一换</div>
        </div>
        <div class="recommend">
          <div class="item" v-for="(item, key) in demoTask.list" :key=key>
            <div class="data">
              <div class="icon"><img :src="item.image"/></div>
              <div class="content">
                <p class="headline"><span>{{getContent(item.title, 7)}}</span><span><em></em>+{{item.money}}元</span></p>
                <p class="sub_title">{{getContent(item.describe, 12)}}</p>
              </div>
              <div class="status" v-if="item.complete_state == 0">
                <div class="btn waiting" @click="jumpUrl(item.jump_url)">立即试玩</div>
              </div>
              <div class="status" v-else>
                <div class="btn finish">已完成</div>
              </div>
            </div>
          </div>          
        </div>
      </div>

      <div class="block step">
        <div class="title">
          <span class="main">步骤说明</span>
        </div>
        <div class="step_info">
          <img src="@/assets/images/step_info.png"/>
        </div>
      </div>

      <div class="block receive">
        <div class="float_button" :class="{disable: isContinue}" @click="receive()">{{getReceiveText}}</div>
      </div>

      <div class="receive_success" :class="{show: isAbleReceive}" v-if="isAbleReceive" @click="close">
        <div class="award">
          <div class="title">领取成功</div>
          <div class="content">
            <div class="total">
              <div class="title">共获得</div>
              <div class="amount">{{statement.total}}<font class="mark">元</font></div>
            </div>
            <div class="detail">
              <div class="base"><p class="money">{{statement.base}}元</p><p class="des">(任务奖励)</p></div>
              <div class="and">+</div>
              <div class="other"><p class="money">{{statement.other}}金币</p><p class="des">(额外奖励)</p></div>
            </div>
          </div>
          <div class="go_sign" @click="toSign()">去签到领取1元</div>
        </div>
      </div>
      <loading :isLoad="isLoad"></loading>
  </div>
</template>

<style>
  body {
    background: #F5F7FA;
  }
</style>

<style scoped>
  .nav {
    display: block;
    width: 100%;
    height: 0.22rem;
    color: #FFF;
    position: fixed;
    z-index: 98;
    top: 0.3rem;
  }
  .nav .content {
    display: flex;
    width: 3.43rem;
    padding: 0 .16rem;
    height: 0.22rem;
    justify-content: space-between;
    align-items: center;
    overflow: hidden;
  }
  .nav .content i {
    float: left;
    width: 0.17rem;
    height: 0.17rem;
    border-left: 2px solid #ffffff;
    border-bottom: 2px solid #ffffff;
    transform: rotate(45deg);
    overflow: hidden;
  }
  .nav .content span {
    float: right;
    font-size: 16px;
    color: #FFF;
  }
  .header {
    display: block;
    width: 100%;
    height: 1.74rem;
    background: url('~@/assets/images/header_bg.png') no-repeat;
    background-size: 3.75rem 1.74rem;
    overflow: hidden;
  }
  .block {
    display: block;
    width: 3.43rem;
    padding: 0 .16rem;
    background: #FFF;
    margin-bottom: 0.12rem;
    overflow: hidden;
  }
  .block .title {
    width: 100%;
    height: 0.22rem;
    line-height: 0.22rem;
    margin-top: 0.2rem;
  }
  .block .title .step_num {
    display: inline-block; 
    width: 0.2rem;
    height: 0.22rem;
    margin-right: 0.08rem;
    background: url('~@/assets/images/step_bg.png') no-repeat;
    background-size: 0.20rem;
    font-size: 14px;
    color: #fff;
    text-align: center;
  }
  .block .title .main {
    display: inline-block;
    font-size: 16px;
    color: #333333;
  }
  .block .title .description {
    display: inline-block;
    font-size: 12px;
    color: #999999;
  }
  .block .title .times {
    display: inline-block;
    font-size: 16px;
    color: #FF4E33;
  }
  .guaguale {
    height: 1.86rem;
  }
  .guaguale .banner {
    display: block;
    width: 100%;
    height: 1.08rem;
    border-radius: 2.5% 3%;
    margin-top: 0.16rem;
    overflow: hidden;
  }
  .guaguale .banner img {
    width: 100%;
    height: auto;
  }
  .try_play .title div {
    display: block;
    float:right;
    width: 0.64rem;
    height: 0.22rem;
    border: 1px solid #47A3FF;
    border-radius: 14px;
    background-color: #FFF;
    text-align: center;
    color: #47A3FF;
    font-size: 12px;
  }
  .try_play .recommend {
    display: block;
    width: 100%;
    margin-top: 0.2rem;
  }
  .try_play .recommend .item {
    display: block;
    width: 100%;
    margin-bottom: 0.2rem;
  }
  .try_play .recommend .item .data {
    display: block;
    width: 100%;
    height: 0.4rem;
    overflow: hidden;
  }
  .try_play .recommend .item .data .icon {
    display: block;
    float: left;
    width: 0.4rem;
    height: 0.4rem;
    border-radius: 0.08rem;
    margin-right: 0.1rem;
    overflow: hidden;
  }
  .try_play .recommend .item .data .icon img {
    width: 100%;
    height: auto;
  }
  .try_play .recommend .item .data .content {
    display: flex;
    float: left;
    width: 2rem;
    height: 0.4rem;
    flex-direction: column;
    justify-content: space-between;
    overflow: hidden;
  }
  .try_play .recommend .item .data .content .headline {
    display: flex;
    color: #333333;
    font-size: 14px;
    line-height: .16rem;
    height: auto;
    flex-direction: row;
    align-items: center;
  }
  .try_play .recommend .item .data .content .headline span:first-child {
    height: .16rem;
    color: #333333;
    font-size: 14px;
    line-height: .16rem;
  }
  .try_play .recommend .item .data .content .headline span:last-child {
    margin-left: 0.12rem;
    font-size: 14px;
    height: .16rem;
    line-height: .16rem;
    color: #FF4E33;
  }
  .try_play .recommend .item .data .content .headline span:last-child em {
    display: inline-block;
    width: 0.16rem;
    height: 0.16rem;
    background: url('~@/assets/images/money_icon.png') no-repeat;
    background-size: 0.16rem;
  }
  .try_play .recommend .item .data .content .sub_title {
    display: block;
    color: #999999;
    font-size: 12px;
    height: .16rem;
  }
  .try_play .recommend .item .data .status {
    display: flex;
    align-items: center;
    width: auto;
    float: right;
    text-align: right;
    height: 0.4rem;
    line-height: 0.4rem;
    overflow: hidden;
  }

  .try_play .recommend .item .data .status .btn{
    display: inline-block;
    width: 0.72rem;
    height: 0.26rem;
    line-height: 0.26rem;
    text-align: center;
    color: #FFF;
    font-size: 12px;
    border-radius: 0.14rem;
    overflow: hidden;
  }
  .try_play .recommend .item .data .status .btn.waiting{
    background-color: #FF7F4B;
  }
  .try_play .recommend .item .data .status .btn.finish{
    background-color: #DBDBDB;
  }
  .try_play .recommend .item .money {
    margin-top: 0.04rem;
    font-size: 12px;
    color: #FF4E33;
    margin-left: 0.5rem;
  }
  .step {
    height: 1.38rem;
    margin-bottom: 0.56rem;
  }
  .step .step_info {
    display: block;
    width: 100%;
    height: 0.56rem;
    margin-top: 0.2rem;
    overflow: hidden;
  }
  .step .step_info img {
    width: 100%;
    height: auto;
  }
  .receive {
    height: 0.64rem;
    margin-bottom: 0;
    position: fixed;
    bottom: 0;
  }
  .receive .float_button {
    width: 3.43rem;
    height: 0.44rem;
    border-radius: 0.24rem;
    line-height: 0.44rem;
    background: #FF7F4B;
    font-size: 18px;
    text-align: center;
    color: #FFF;
    margin-top: 0.1rem;
  }
  .receive .disable {
    background: #DBDBDB;
  }
  .receive_success {
    display: none;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 3.75rem;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.75);
    position: fixed;
    z-index: 99;
    top: 0;
  }
  .receive_success.show {
    display: flex;
  }
  .receive_success .award {
    display: block;
    width: 3.1rem;
    height: 2.7rem;
    background-color: #FFF;
    border-radius: 0.08rem;
    overflow: hidden;
  }
  .receive_success .award .title {
    margin-top: 0.24rem;
    font-size: 20px;
    color: #333333;
    text-align: center;
  }
  .receive_success .award .content {
    margin: 0 auto;
    margin-top: 0.16rem;
    width: 2.7rem;
    height: 1.1rem;
    background-color: #FFF7F2;
    border-radius: 0.04rem;
  }
  .receive_success .award .content .total {
    display: block;
    width: 0.94rem;
    height: 0.48rem;
    background-color: #FF7F4B;
    border-radius: 0 0 0.08rem 0.08rem;
    margin: 0 auto;
    text-align: center;
    color: #FFF;
    overflow: hidden;
  }
  .receive_success .award .content .total .title {
    margin-top: 0.05rem;
    font-size: 12px;
    color: #FFF;
  }
  .receive_success .award .content .total .amount {
    font-size: 22px;
  }
  .receive_success .award .content .total .mark {
    font-size: 12px;
  }
  .receive_success .award .content .detail {
    display: flex;
    width: 100%;
    margin-top: 0.16rem;
    justify-content: center;
  }
  .receive_success .award .content .detail .money {
    font-size: 14px;
  }
  .receive_success .award .content .detail .des {
    font-size: 10px;
  }
  .receive_success .award .content .detail .base {
    text-align: right;
    color: #1F8FFF;
  }
  .receive_success .award .content .detail .and {
    width: 0.5rem;
    text-align: center;
    color: #FF4E33;
    font-size: 16px;
  }
  .receive_success .award .content .detail .other {
    text-align: left;
    color: #FF4E33;
  }
  .receive_success .award .go_sign {
    display: block;
    width: 2.28rem;
    height: 0.44rem;
    background-color: #FF7F4B;
    border-radius: 0.24rem;
    font-size: 16px;
    text-align: center;
    line-height: 0.44rem;
    color: #FFF;
    margin: 0 auto;
    margin-top: 0.24rem;
  }
</style>

<script>
import Loading from '@/components/Loading'
import Ad6 from '@/assets/images/card.png'
import Ad13 from '@/assets/images/card_13.png'

export default {
  created() {
    this.userid = this.getCookie('userid')
    this.deviceid = this.getCookie('device_id')
    this.appVersion = this.getCookie('app_version')
    this.site_id = this.getCookie('site_id')
    this.soft_id = this.getCookie('soft_id')
    
    if (this.$route.query.debug == 1) {
      this.userid = this.$route.query.userid
      this.deviceid = this.$route.query.deviceid
      this.appVersion = this.$route.query.app_version
      this.site_id = this.$route.query.site_id
      this.soft_id = this.$route.query.soft_id
    }
    // this.userid = '34617925'
    // this.deviceid = '860921041770328'
    this.getTodayTask()
  },
  components: {
    Loading
  },
  data() {
    return {
      userid: '',
      deviceid: '',
      appVersion: '',
      site_id: '',
      soft_id: '',
      hasExperienceTask: true,
      experienceTask: {},
      experienceTitle: '',
      experienceImg: '',
      demoTask:[],
      experienceStep: '0/0',
      demoStep: '0/0',
      receiveCoin: 0,
      isReceive: 0,
      isComplete: 0,
      statement: {
        total: 0.00,
        base: 0.00,
        other: 0.00
      },
      isAbleReceive: false,
      isLoad: false,
    }
  },
  methods: {
    getCookie: function (name) {
      var strcookie = document.cookie; //获取cookie字符串
      var arrcookie = strcookie.split("; "); //分割
      //遍历匹配
      for (var i = 0; i < arrcookie.length; i++) {
        var arr = arrcookie[i].split("=");
        if (arr[0] == name) {
          return arr[1];
        }
      }
      return ""
    },
    getTodayTask: function () {
      let params = {
        userid: this.userid,
        device_id: this.deviceid,
        app_version: this.appVersion,
        site_id: this.site_id,
        soft_id: this.soft_id
      }
      
      this.isLoad = true
      this.$http.get('/api/user_web/today_task_index', {params: params}).then((res) => {
        this.handleReponse(res)
      })
    },
    refreshTask: function () {
      let params = {
        userid: this.userid,
        device_id: this.deviceid,
        app_version: this.appVersion,
        site_id: this.site_id,
        soft_id: this.soft_id
      }
      
      this.isLoad = true
      this.$http.get('/api/user_web/today_task_refresh', {params: params}).then((res) => {
        this.handleReponse(res)
      })
    },
    handleReponse: function (response) {
      let data = response.data
      this.receiveCoin = data.receive_coin
      this.experienceStep = data.experience_num
      this.demoStep = data.demo_num
      this.demoTask = data.demo_task
      this.isReceive = data.is_receive
      this.isComplete = data.is_complete
      this.isLoad = false

      if (data.hasOwnProperty('experience_task')) {
        this.experienceTask = data.experience_task.list[0]
        this.experienceTitle = data.experience_task.title_1
        switch(this.experienceTask.type) {
          case "6":
            this.experienceImg = Ad6
            break
          case "13":
            this.experienceImg = Ad13
            break
        }
        this.hasExperienceTask = true
      } else {
        this.hasExperienceTask = false
      }
    },
    getContent: function(text, len = 0) {
      if (len > 0 && text.length > len) {
        text = text.substring(0, len)
        text += '...'
      }
      return text
    },
    jumpUrl: function(url) {
      window.location.href = url
    },
    receive: function() {
      // 领取条件判断
      if (this.isContinue) {
        return
      }

      let params = {userid: this.userid}
      this.isLoad = true
      this.$http.get('/api/user_web/today_task_receive', {params: params}).then((res) => {
        this.isLoad = false
        let data = res.data
        this.statement.total = data.summary_money
        this.statement.base = data.demo_money
        this.statement.other = data.coin
        this.isAbleReceive = true
        this.isReceive = 1        
      })
    },
    toSign: function () {
      // 跳转
      window.location.href="lezhuan://jump?type=9"
      window.injectedObject.setJsContent('closeWebview', '')
    },
    close: function () {
      this.isAbleReceive = false
    },
    goBack: function () {
      if (this.isComplete == 0) {
        window.injectedObject.setJsContent('show_back_confirm_dialog','确认要放弃今日任务的额外奖励码?')
        return
      }
      window.injectedObject.setJsContent('closeWebview', '')
    },
    customer: function () {
      window.injectedObject.setJsContent('qqservice', '800184512')
    }
  },
  computed: {
    isContinue: function () {
      return this.isReceive == 1 || this.isComplete == 0? true : false
    },
    getReceiveText: function () {
      return this.isReceive == 1? '今日奖励已领取' : '领取额外奖励'+ this.receiveCoin +'金币'
    }
  }
}
</script>